<template>
  <div class="availibilityDetailsVue">
    <!-- Tab content area -->
    <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3">
        <div class="c-user-tab-content clearfix o-skillset-area">
            <div class="col-md-12">
                <h2 class="h2">
                    {{ $t('recurring_conflicts') }}:                     
                </h2>
                <p class="h5-v2">
                    <strong style="text-transform: capitalize;"> {{ $t('note') }}: </strong>
                    {{ $t('recurring_unavailability_note') }}
                </p>
                <p class="h5-v2">{{ $t('un_availability_entry_note_1') }} 1:00-18:30{{ $t('un_availability_entry_note_2') }} 1:00-18:30,20:30-22:30)</p>
            </div>

            <div class="col-md-12">
                <ul class="c-skillset c-skillset--avail">
                    <li class="table-td-border-right">
                        <h6 class="h6">{{ $t('sunday') }}</h6>
                        <div v-if="Object.keys(getAvailibityList['1']).length === 0" class="o-avail-tag">
                            <p class="h5-v2">{{ $t('available') }}</p>
                        </div>
                        <div v-else v-for="(getAvail,index) in getAvailibityList['1']" :key="index" class="o-ocup-tag">
                            <p class="h5-v2">{{ $t('occupied_from') + ' ' }}  {{getAvail[0]}} - {{getAvail[1]}}</p>
                        </div>
                    </li>
                    <li class="table-td-border-right">
                        <h6 class="h6">{{ $t('monday') }}</h6>
                        <div v-if="Object.keys(getAvailibityList['2']).length === 0" class="o-avail-tag">
                            <p class="h5-v2">{{ $t('available') }}</p>
                        </div>
                        <div v-else v-for="(getAvail,index) in getAvailibityList['2']" :key="index" class="o-ocup-tag">
                            <p class="h5-v2">{{ $t('occupied_from') + ' ' }}  {{getAvail[0]}} - {{getAvail[1]}}</p>
                        </div>
                    </li>
                    <li class="table-td-border-right">
                        <h6 class="h6">{{ $t('tuesday') }}</h6>
                        <div v-if="Object.keys(getAvailibityList['3']).length === 0" class="o-avail-tag">
                            <p class="h5-v2">{{ $t('available') }}</p>
                        </div>
                        <div v-else v-for="(getAvail,index) in getAvailibityList['3']" :key="index" class="o-ocup-tag">
                            <p class="h5-v2">{{ $t('occupied_from') + ' ' }}  {{getAvail[0]}} - {{getAvail[1]}}</p>
                        </div>
                    </li>
                    <li class="">
                        <h6 class="h6">{{ $t('wednesday') }}</h6>
                        <div v-if="Object.keys(getAvailibityList['4']).length === 0" class="o-avail-tag">
                            <p class="h5-v2">{{ $t('available') }}</p>
                        </div>
                        <div v-else v-for="(getAvail,index) in getAvailibityList['4']" :key="index" class="o-ocup-tag">
                            <p class="h5-v2">{{ $t('occupied_from') + ' ' }}  {{getAvail[0]}} - {{getAvail[1]}}</p>
                        </div>
                    </li>
                    <li class="table-td-border-right">
                        <h6 class="h6">{{ $t('thursday') }}</h6>
                         <div v-if="Object.keys(getAvailibityList['5']).length === 0" class="o-avail-tag">
                            <p class="h5-v2">{{ $t('available') }}</p>
                        </div>
                        <div v-else v-for="(getAvail,index) in getAvailibityList['5']" :key="index" class="o-ocup-tag">
                            <p class="h5-v2">{{ $t('occupied_from') + ' ' }}  {{getAvail[0]}} - {{getAvail[1]}}</p>
                        </div>
                    </li>
                    
                    <li class="table-td-border-right">
                        <h6 class="h6">{{ $t('friday') }}</h6>
                        <div v-if="Object.keys(getAvailibityList['6']).length === 0" class="o-avail-tag">
                            <p class="h5-v2">{{ $t('available') }}</p>
                        </div>
                        <div v-else v-for="(getAvail,index) in getAvailibityList['6']" :key="index" class="o-ocup-tag">
                            <p class="h5-v2">{{ $t('occupied_from') + ' ' }}  {{getAvail[0]}} - {{getAvail[1]}}</p>
                        </div>
                    </li>
                    
                    <li class="table-td-border-right">
                        <h6 class="h6">{{ $t('saturday') }}</h6>
                        <div v-if="Object.keys(getAvailibityList['7']).length === 0" class="o-avail-tag">
                            <p class="h5-v2">{{ $t('available') }}</p>
                        </div>
                        <div v-else v-for="(getAvail,index) in getAvailibityList['7']" :key="index" class="o-ocup-tag">
                            <p class="h5-v2">{{ $t('occupied_from') + ' ' }}  {{getAvail[0]}} - {{getAvail[1]}}</p>
                        </div>
                    </li>    
                </ul>                        
            </div>
           
        </div>
    </div>
    <div class="col-sm-12 o-no-padding c-responsive-fixwidth">
        <div class="col-sm-6 o-right-padding-only">
            <div class="c-common-space c-common-box-shadow c-radius3" v-loading="vacationsLoading">
                <div class="c-user-tab-content clearfix o-skillset-area js-employee-boxHeight">
                    <div class="col-md-12">
                        <h2 class="h2">{{ $t('running') }}:</h2>
                        <div v-for="(vacation,index) in running" :key="index" class="o-running-strip">
                            <div class="u-pad-all-15 c-radius3 u-alert-bg">
                            <strong>{{ $t('label') }}: </strong> {{vacation.label}}
                            </div>
                            <div class="u-pad-all-15 c-radius3 o-vacation-label">
                                {{ $t('on_leave_from') }} <strong>{{getDateFormat(vacation.start)}}</strong> {{ $t('to') }} <strong>{{getDateFormat(vacation.end)}}</strong>.
                                <span v-if="userType=='client-admin' || userType=='power-user'" class="o-float-right o-upcome-setting">
                                <a href="javascript: void(0)" @click="editVacation(vacation.id)"><i class="fa fa-pencil"></i></a>
                                <a href="javascript: void(0)" @click="deleteVacation(vacation.id)"><i class="fa fa-trash"></i></a>
                                </span>
                            </div>  
                        </div>
                        <div v-if="running.length == 0" class="u-pad-all-15 c-radius3 u-alert-bg o-running-strip">
                            {{ $t('currently_available') }}
                        </div>                                                   

                    </div>
                    <div class="col-md-12">
                        <h2 class="h2">{{ $t('upcoming') }}:</h2>
                        <ul class="o-employee-upcoming o-running-strip">

                            <li v-for="(vacation,index) in upcoming" :key="index">
                                <div class="u-pad-all-15 c-radius3 o-upcome-list">
                                    <strong>{{ $t('label') }}: </strong> {{vacation.label}}
                                </div>
                                <div class="u-pad-all-15 c-radius3 o-upcome-list o-vacation-label">
                                    {{ $t('on_leave_from') }} <strong>{{getDateFormat(vacation.start)}}</strong> {{ $t('to')}} <strong>{{getDateFormat(vacation.end)}}</strong>
                                    <span :class="{'isDisabled':!getPower('editEmployee')}" class="o-float-right o-upcome-setting">
                                        <a href="javascript: void(0)" @click="editVacation(vacation.id)"><i class="fa fa-pencil"></i></a>
                                        <a href="javascript: void(0)" @click="deleteVacation(vacation.id)"><i class="fa fa-trash"></i></a>
                                    </span>
                                </div>
                            </li>
                            <li v-if="upcoming.length == 0">
                                <div class="u-pad-all-15 c-radius3 o-upcome-list">
                                    {{ $t('no_upcoming_leave_found') }}
                                </div>
                            </li>

                        </ul>
                        <div class="o-employe-view">
                            <!-- <a @click="addVacationHistory()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-eye" aria-hidden="true"></i> View History</a> -->

                            <a href="javascript: void(0)" @click="gotoVacationLog()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-eye" aria-hidden="true"></i>{{ $t('vacation_log') }}</a>
                            <!-- <a href="https://callsteward.freshdesk.com/a/solutions/articles/24000057026" target="_blank" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-green">Policy</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'isDisabled':!getPower('editEmployee')}" class="col-sm-6 o-left-padding-only">
            <div class="c-common-space c-common-box-shadow c-radius3">
                <div class="c-user-tab-content clearfix o-skillset-area js-employee-boxAppend" v-loading="vacationAddLoading">
                    <div class="col-md-12">
                        <h2 class="h2">{{ $t('request_time_off') }}:</h2>
                    </div>
                    <div class="col-sm-12 o-no-padding o-running-strip">
                        
                        <div class="col-sm-12 o-no-padding">
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="employee-label-text">{{ $t('start_date') }}:</label>
                                    <label class="employee-label-input">
                                    <el-date-picker 
                                    type="date" 
                                    class="custom_date"
                                    :placeholder="getDatePlaceholder()"  
                                    style="width: 100%;" 
                                    v-validate="{ required: true}" 
                                    name="startDate" 
                                    v-model="empAvail.startDate"
                                    :format="getDisplayFormat()"
                                    value-format="yyyy-MM-dd"
                                    @change="setEndDate()"
                                    >    
                                    </el-date-picker>
                                    <span v-show="errors.has('startDate') && this.validation_err!=0" class="err-msg">{{ errors.first('startDate') }}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="employee-label-text">{{ $t('start_time') }}:</label>
                                    <label class="employee-label-input">
                                <date-picker 
                                name="startTime" 
                                placeholder="HH:MM AM"
                                v-validate="{required: true}" 
                                v-model="empAvail.startTime" 
                                :config="config"
                                >
                                </date-picker>
                                <span v-show="errors.has('startTime') && this.validation_err!=0" class="err-msg">{{ errors.first('startTime') }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 o-no-padding">
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="employee-label-text">{{ $t('end_date') }}:</label>
                                    <label class="employee-label-input">
                                <el-date-picker 
                                type="date" 
                                class="custom_date"
                                :placeholder="getDatePlaceholder()" 
                                style="width: 100%;" 
                                v-validate="{ required: true}" 
                                name="endDate" 
                                :picker-options="getPickerOption(empAvail.startDate)"
                                v-model="empAvail.endDate"
                                :format="getDisplayFormat()"
                                value-format="yyyy-MM-dd"
                                >    
                                </el-date-picker>
                                <span v-show="errors.has('endDate') && this.validation_err!=0" class="err-msg">{{ errors.first('endDate') }}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="employee-label-text">{{ $t('end_time') }}:</label>
                                    <label class="employee-label-input">
                                <date-picker 
                                name="endTime" 
                                placeholder="HH:MM AM"
                                v-validate="{required: true}" 
                                v-model="empAvail.endTime" 
                                :config="config"
                                >
                                </date-picker>
                                <span v-show="errors.has('endTime') && this.validation_err!=0" class="err-msg">{{ errors.first('endTime') }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 o-no-padding">
                            <div class="col-sm-12">
                                <div class="form-group ">
                                <label class="employee-label-text">{{$t('comments')}}:</label>
                                    <textarea autocomplete="off" v-model="empAvail.label" name="label" class="form-control" rows="4" :placeholder="$t('enter_your_comments')"></textarea>
                                    <span v-show="errors.has('label') && this.validation_err!=0" class="err-msg">{{ errors.first('label') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="o-employe-view">
                            <a href="javascript: void(0)" @click="addVacation()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> {{ $t('add_vacation') }} </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- <div class="col-sm-12 o-no-padding c-responsive-fixwidth">
        <div class="col-sm-6 o-right-padding-only">
            <div class="c-common-space c-common-box-shadow c-radius3">
                <div class="c-user-tab-content clearfix o-skillset-area js-employee-boxHeight">
                    <div class="col-md-12">
                        <h2 class="h2">Running:</h2>
                        <div v-for="vacation in running" class="o-running-strip">
                          <div class="u-pad-all-15 c-radius3 u-alert-bg">
                            <strong>Label: </strong> {{vacation.label}}
                          </div>
                          <div class="u-pad-all-15 c-radius3 o-vacation-label">
                              On leave from <strong>{{getDateFormat(vacation.start)}}</strong> to <strong>{{getDateFormat(vacation.end)}}</strong>.
                          </div>
                        </div>
                        <div v-if="running.length == 0" class="u-pad-all-15 c-radius3 u-alert-bg o-running-strip">
                            Currently Available
                        </div>

                    </div>
                    <div class="col-md-12">
                        <h2 class="h2">Upcoming:</h2>
                        <ul class="o-employee-upcoming o-running-strip">

                            <li v-for="vacation in upcoming">
                                <div class="u-pad-all-15 c-radius3 o-upcome-list">
                                  <strong>Label: </strong> {{vacation.label}}
                                </div>

                                <div class="u-pad-all-15 c-radius3 o-upcome-list o-vacation-label">
                                    On leave from <strong>{{getDateFormat(vacation.start)}}</strong> to <strong>{{getDateFormat(vacation.end)}}</strong>
                                    <span class="o-float-right o-upcome-setting">
                                        <a @click="editVacation(vacation.id)"><i class="fa fa-pencil"></i></a>
                                        <a @click="deleteVacation(vacation.id)"><i class="fa fa-trash"></i></a>
                                    </span>
                                </div>
                            </li>

                            <li v-if="upcoming.length == 0">
                                <div class="u-pad-all-15 c-radius3 o-upcome-list">
                                    No Upcomming Leave found
                                </div>
                            </li>


                        </ul>
                        <div class="o-employe-view">
                            <a @click="addVacationHistory()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-eye" aria-hidden="true"></i> View History</a>
                            <a @click="gotoVacationLog()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-eye" aria-hidden="true"></i>Vacation Log</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6 o-left-padding-only">
            <div class="c-common-space c-common-box-shadow c-radius3">
                <div class="c-user-tab-content clearfix o-skillset-area js-employee-boxAppend" style="height: 389px;">
                    <div class="col-md-12">
                        <h2 class="h2">Request time off:</h2>
                    </div>
                    <div class="col-sm-12  o-no-padding o-running-strip">
                      <div class="col-sm-2">
                        <div class="form-group ">
                            <label class="employee-label-text">Label:</label>
                        </div>
                      </div>
                      <div class="col-sm-10">
                        <div class="form-group ">
                               <textarea v-model="empAvail.label" name="label" class="form-control" rows="2" placeholder="Text Area"></textarea>
                               <span v-show="errors.has('label') && this.validation_err!=0" class="err-msg">{{ errors.first('label') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 o-no-padding o-running-strip">
                       <div class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="employee-label-text">Start Date:</label>
                                <label class="employee-label-input">
                                   <el-date-picker 
                                   type="date" 
                                   class="custom_date"
                                   placeholder="dd/mm/yyyy"  
                                   style="width: 100%;" 
                                   v-validate="{ required: true}" 
                                   name="startDate" 
                                   v-model="empAvail.startDate"
                                   format="dd/MM/yyyy"
                                   value-format="yyyy-MM-dd"
                                   >    
                                   </el-date-picker>
                                   <span v-show="errors.has('startDate') && this.validation_err!=0" class="err-msg">{{ errors.first('startDate') }}</span>
                                </label>
                            </div>
                        </div>
                                <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="employee-label-text">Start Time:</label>
                                <label class="employee-label-input">
                               <date-picker 
                               name="startTime" 
                               v-validate="{required: true}" 
                               v-model="empAvail.startTime" 
                               :config="config"
                               >
                               </date-picker>
                               <span v-show="errors.has('startTime') && this.validation_err!=0" class="err-msg">{{ errors.first('startTime') }}</span>
                                </label>
                            </div>
                        </div>
                            </div>
                        </div>
                       <div class="row">
                           <div class="col-sm-12">
                                <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="employee-label-text">End Date:</label>
                                <label class="employee-label-input">
                               <el-date-picker 
                               type="date" 
                               class="custom_date"
                               placeholder="dd/mm/yyyy"  
                               style="width: 100%;" 
                               v-validate="{ required: true}" 
                               name="endDate" 
                               v-model="empAvail.endDate"
                               format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                               >    
                               </el-date-picker>
                               <span v-show="errors.has('endDate') && this.validation_err!=0" class="err-msg">{{ errors.first('endDate') }}</span>
                                </label>
                            </div>
                        </div>
                                <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="employee-label-text">End Time:</label>
                                <label class="employee-label-input">
                               <date-picker 
                               name="endTime" 
                               v-validate="{required: true}" 
                               v-model="empAvail.endTime" 
                               :config="config"
                               >
                               </date-picker>
                               <span v-show="errors.has('endTime') && this.validation_err!=0" class="err-msg">{{ errors.first('endTime') }}</span>
                                </label>
                            </div>
                        </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="o-employe-view">
                            <a @click="addVacation()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> Add Vacation</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- /Tab content area -->

    <modal name="vacation-details"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
        <div  tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header text-center">
                        <button @click="closeVacationDetails()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h1 class="modal-title">{{ $t('vacation') }}</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                        <div class="row">
                            <div class="col-sm-12 o-no-padding o-running-strip">
                                <div class="row">
                                    <h1 class="h2 o-decline-text">
                                        <!-- {{vacation_conflict_status}} -   -->
                                        Contact your Dispatcher! Booking Conflict - <br />
                                        <strong>{{getDate(assignVacation.start)}} {{getTime(assignVacation.start)}}</strong>
                                        to 
                                        <strong>{{getDate(assignVacation.end)}} {{getTime(assignVacation.end)}}</strong></h1>

                                </div>

                            </div>
                        </div>
                    </div>                        

                    <div class="modal-footer text-center">
                        
                    </div>
                
                </div>
                <!-- /.modal-content -->
            </div>
        </div>
    </modal> 

    <modal name="vacation-edit"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
        <div tabindex="-1" role="dialog">
            <div role="document">
                <div class="modal-content o-common-modal-content" v-loading="vacationEditLoading">
                    <div class="modal-header text-center">
                        <button @click="closeVacationEdit()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h1 class="modal-title">{{ $t('edit_vacation') }}</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body o-vacation-edit-modal">
                        <div class="row">
                            <div class="col-sm-12 o-running-strip">
                                <div class="row">

                                <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="employee-label-text">{{ $t('start_date') }}:</label>
                                    <label class="employee-label-input">
                                        <el-date-picker 
                                        type="date" 
                                        class="custom_date"
                                        :placeholder="getDatePlaceholder()"  
                                        style="width: 100%;" 
                                        v-validate="" 
                                        name="updatestartDate" 
                                        v-model="empAvailupdate.startDate"
                                        :format="getDisplayFormat()"
                                        value-format="yyyy-MM-dd"
                                        >    
                                        </el-date-picker>
                                        <!-- <span v-show="errors.has('updatestartDate') && this.validation_err!=0" class="err-msg">{{ errors.first('updatestartDate') }}</span> -->
                                    </label>
                                </div>
                                </div>
                                <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="employee-label-text">{{ $t('start_time') }}:</label>
                                    <label class="employee-label-input">
                                    <date-picker 
                                    name="updatestartTime" 
                                    v-validate="" 
                                    placeholder="HH:MM AM"
                                    v-model="empAvailupdate.startTime" 
                                    :config="config"
                                    >
                                    </date-picker>
                                    <!-- <span v-show="errors.has('updatestartTime') && this.validation_err!=0" class="err-msg">{{ errors.first('updatestartTime') }}</span> -->
                                    </label>
                                </div>
                                </div>
                                </div>
                                <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="employee-label-text">{{ $t('end_date') }}:</label>
                                        <label class="employee-label-input">
                                        <el-date-picker 
                                        type="date" 
                                        class="custom_date"
                                        :placeholder="getDatePlaceholder()" 
                                        style="width: 100%;" 
                                        v-validate="" 
                                        name="updateendDate" 
                                        :picker-options="getPickerOption(empAvailupdate.startDate)"
                                        v-model="empAvailupdate.endDate"
                                        :format="getDisplayFormat()"
                                        value-format="yyyy-MM-dd"
                                        >    
                                        </el-date-picker>
                                        <!-- <span v-show="errors.has('updateendDate') && this.validation_err!=0" class="err-msg">{{ errors.first('updateendDate') }}</span> -->
                                        </label>
                                    </div>
                                </div>
                                    <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="employee-label-text">{{ $t('end_time') }}</label>
                                        <label class="employee-label-input">
                                        <date-picker 
                                        name="updateendTime" 
                                        placeholder="HH:MM AM"
                                        v-validate="" 
                                        v-model="empAvailupdate.endTime" 
                                        :config="config"
                                        >
                                        </date-picker>
                                        <!-- <span v-show="errors.has('updateendTime') && this.validation_err!=0" class="err-msg">{{ errors.first('updateendTime') }}</span> -->
                                        </label>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-running-strip">
                                <div>
                                <div class="col-sm-2">
                                    <div class="form-group ">
                                        <label class="employee-label-text">{{ $t('label') }}:</label>
                                    </div>
                                </div>
                                <div class="col-sm-10">
                                    <div class="form-group ">
                                        <!-- <label class="employee-label-input"> -->
                                            <textarea autocomplete="off" v-model="empAvailupdate.label" name="label" class="form-control" rows="2" :placeholder="$t('text_area')"></textarea>
                                            <span v-show="errors.has('label') && this.validation_err!=0" class="err-msg">{{ errors.first('label') }}</span>
                                        <!-- </label> -->
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>

                    </div>                        

                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeVacationEdit()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> {{ $t('cancel') }}</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="vacationUpdate()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> {{ $t('save') }}</a>
                            </li>
                        </ul>
                    </div>
                
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </modal> 

    <modal name="vacation-history"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
        <div  tabindex="-1" role="dialog">
            <div  role="document" v-loading="vacationsHistoryLoading">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header text-center">
                        <button @click="closeVacationHistory()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h1 class="modal-title">{{ $t('vacation_history') }}</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body o-no-padding-modal">
                            <div v-for="(vacation,idx) in vacationHistory" :key="idx" class="o-running-strip o-vacation-history">
                                {{ $t('took_leave_from') }} <strong>{{getDateFormat(vacation.start)}}</strong> {{$t('to')}} <strong>{{getDateFormat(vacation.end)}}</strong>.
                            </div> 
                            <div v-if="vacationHistory.length == 0" class="o-running-strip o-vacation-history text-center">
                                {{ $t('no_data_found') }}
                            </div>   
                    </div>                        

                    <div class="modal-footer text-center">
                        
                    </div>
                
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </modal>
  </div>
</template>

<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        bus
    } from '../../main';
    import service from '../../services.js';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    export default {
        props: {
            empDetails: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                vacationsHistoryLoading: false,
                vacationsLoading: false,
                vacationAddLoading: false,
                vacationEditLoading: false,
                fullName:'',
                getAvailibityList: {},
                running: [],
                upcoming: [],
                validation_err: 0,
                vacationalId: '',
                assignVacation: '',
                vacationList: [],
                vacation_conflict_status:'',
                vacationHistory: [],
                selectedVacationId: '',
                userType:'',
                empAvailability: {
                    sunday: '',
                },
                empAvail: {
                    startDate: '',
                    endDate: '',
                    startTime: '',
                    endTime: '',
                    label:'',
                },
                empAvailupdate: {
                    startDate: '',
                    endDate: '',
                    startTime: '',
                    endTime: '',
                    label:'',
                },
                config: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        vertical: 'bottom',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                        // Handle case where user inputs 3 or 4 digits (e.g., 800 or 1230)
                        const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                        if (match) {
                            let hours = parseInt(match[1], 10);
                            let minutes = match[2] ? parseInt(match[2], 10) : 0;

                            // Adjust hours if necessary for AM/PM logic (optional)
                            // if (hours > 12) hours -= 12;

                            // Return a Moment.js object
                            return moment({ hour: hours, minute: minutes });
                        }
                        }

                        // Default fallback to create a Moment object
                        return moment(inputDate, 'hh:mm A');
                    }
                },
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                currentEmployeeID: 'currentEmployeeID',
                userID: 'userID',
            })
        },
        watch: {
            empDetails: function(newData) {
                //console.log('DATA', newData);
                this.vacationalId = newData.employable.id;
                this.fullName= newData.employable.first_name+" "+this.newData.employable.last_name;
            }
        },
        methods: {
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            setEndDate() {
                // console.log("Check");
                this.empAvail.endDate = this.empAvail.startDate;
                // this.empAvailUpdate.endDate = this.empAvailUpdate.startDate;
            },
            
            getPickerOption(startDate){
                // this.empAvail.endDate = this.empAvail.startDate;
                return {
                    disabledDate(time) {
                        return time.getTime() < +new Date(startDate).setDate(new Date(startDate).getDate() - 1);
                    }
                }
            },

            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                // console.log(format);
                return format?format:'MM/dd/yyyy';
            },

            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },

            gotoVacationLog(){
              this.$store.dispatch('setActionLogType', {
                'logFrom': 'employeeDetails',
                'logUser': this.fullName,
              });
              this.$router.push({
                    'path': '/vacationLog/'+ btoa(this.vacationalId)
              });
            },

            deleteVacation(id) {                
                this.$confirm(this.$t('permanent_delete_warn'), this.$t('warning'), {
                    confirmButtonText: this.$t('okay'),
                    cancelButtonText: this.$t('cancel'),
                    type: 'warning'
                }).then(() => {
                    this.vacationsLoading = true;
                    service.del('vacation/' + id, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'initiator': this.userID,
                        'affector': this.vacationalId,
                        // 'employeeId': atob(this.$route.params.employeeId)
                    }).
                    then((res) => {
                        this.vacationsLoading = false;
                        //console.log(res);
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: this.$t('delete_completed')
                        });
                        this.getVacation();

                    }).catch((err) => {
                        this.vacationsLoading = false;
                        this.$message({
                            type: 'error',
                            message: this.$t('something_went_wrong')
                        });
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message:this.$t('delete_canceled')
                    });
                });
            },

            closeVacationHistory() {
                this.$modal.hide("vacation-history");
            },

            addVacationHistory() {
                this.$modal.show("vacation-history");
            },

            vacationUpdate() {
                //let selectVacation = this.empAvail;
                //console.log(selectVacation);
                let formData = {
                    end: this.empAvailupdate.endDate + " " + dateTimeConvert.convertTo24Hours(this.empAvailupdate.endTime),
                    start: this.empAvailupdate.startDate + " " + dateTimeConvert.convertTo24Hours(this.empAvailupdate.startTime),
                    label: this.empAvailupdate.label,
                };
                //console.log('form data', formData);
                if(moment(formData.start, 'YYYY-MM-DD HH:mm:ss') < moment(formData.end, 'YYYY-MM-DD HH:mm:ss')){
                  this.vacationEditLoading = true;
                  service.put('vacation/' + this.selectedVacationId, formData, {
                      'Authorization': this.userToken,
                      'cs3-context-role': this.userRole,
                      'cs3-context-clientId': this.userClientID,
                      'initiator': this.userID,
                      'affector': this.vacationalId,
                    //   'employeeId': atob(this.$route.params.employeeId)
                  }).then((res) => {
                      
                      //console.log(res);
                      this.vacationEditLoading = false;
                      if (res.data.result.vacation_process == 1) {
                          this.$notify({
                              title: this.$t('success'),
                              message: this.$t('vacation_update_success'),
                              type: 'success'
                          });
                          this.$modal.hide("vacation-edit");
                          this.getVacation()
                          this.empAvailupdate.startDate = "";
                          this.empAvailupdate.endDate = "";
                          this.empAvailupdate.startTime = "";
                          this.empAvailupdate.endTime = "";
                          this.empAvailupdate.label = "";

                      } else {
                          this.$modal.hide("vacation-edit");
                          this.$modal.show("vacation-details");
                          this.assignVacation = res.data.result.info;
                          this.vacation_conflict_status=res.data.status_message;
                      }

                  }).catch((err) => {
                      this.vacationEditLoading = false;
                      this.$notify({
                        title: this.$t('error'),
                        message: this.$t('something_went_wrong'),
                        type: 'error'
                      });
                      console.log(err);
                  });
                //console.log(fromData);
                }else{
                  this.$notify({
                      title: this.$t('error'),
                      message: this.$t('vacation_end_after_start'),
                      type: 'error'
                  });
                }
            },

            editVacation(id) {
                this.selectedVacationId = id;
                this.$modal.show("vacation-edit");
                service.get('vacation/' + id, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    // 'employeeId': this.employeeId
                }).then((res) => {
                    //console.log(res);
                    $('.custom_date input').attr('readonly','readonly');
                    let vacDetails = res.data.result;
                    this.empAvailupdate.startDate = vacDetails.start.split(" ")[0];
                    this.empAvailupdate.endDate = vacDetails.end.split(" ")[0];
                    this.empAvailupdate.startTime = vacDetails.start.split(" ")[1];
                    this.empAvailupdate.endTime = vacDetails.end.split(" ")[1];
                    this.empAvailupdate.label = vacDetails.label;

                }).catch((err) => {
                    console.log(err);
                });
            },

            closeVacationEdit() {
                this.$modal.hide("vacation-edit");
            },

            getTime(dateTime) {
                return dateTimeConvert.globalTime(dateTime);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },

            getDate(str) {
                //console.log(str);
                if (typeof str != "undefined") {
                    return dateTimeConvert.globalDate(str);
                    //var date = str.split(" ");
                    //return date[0];
                }
            },

            getDateFormat(dateTime) {
                return dateTimeConvert.globalDate(dateTime);
                //var date = dateTimeConvert.extractDateOnly(dateTime);
                //return dateTimeConvert.extractDateOnly(dateTime);
            },

            closeVacationDetails() {
                this.$modal.hide("vacation-details");
            },

            addVacation() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        //let selectVacation = this.empAvail;
                        //console.log(selectVacation);
                        let formData = {
                            vacationable_id: this.vacationalId,
                            end: this.empAvail.endDate + " " + dateTimeConvert.convertTo24Hours(this.empAvail.endTime),
                            start: this.empAvail.startDate + " " + dateTimeConvert.convertTo24Hours(this.empAvail.startTime),
                            label: this.empAvail.label,
                        };
                        if(moment(formData.start, 'YYYY-MM-DD HH:mm:ss') < moment(formData.end, 'YYYY-MM-DD HH:mm:ss')){
                          this.vacationAddLoading = true;
                          //console.log('form data', formData);
                          service.post('vacation', formData, {
                              'Authorization': this.userToken,
                              'cs3-context-role': this.userRole,
                              'cs3-context-clientId': this.userClientID,
                              'initiator': this.userID,
                              'affector': this.vacationalId,
                            //   'employeeId': atob(this.$route.params.employeeId)
                          }).then((res) => {
                              this.vacationAddLoading = false;
                              //console.log(res);
                              if (res.data.result.vacation_process == 1) {
                                  this.$notify({
                                      title: this.$t('success'),
                                      message: this.$t('vacation_update_success'),
                                      type: 'success'
                                  });
                                  this.empAvail.startDate = "";
                                  this.empAvail.endDate = "";
                                  this.empAvail.startTime = "";
                                  this.empAvail.endTime = "";
                                  this.empAvail.label = "";
                                  this.getVacation();

                              } else {
                                  this.$modal.show("vacation-details");
                                  this.assignVacation = res.data.result.info;
                                  this.vacation_conflict_status=res.data.status_message;
                                  //console.log(res.data.result.info.start);
                              }

                          }).catch((err) => {
                               this.vacationAddLoading = false;
                               this.$notify({
                                title: this.$t('error'),
                                message: this.$t('something_went_wrong'),
                                type: 'error'
                              }); 
                              console.log(err);
                          });
                        }else{
                          this.$notify({
                              title: this.$t('error'),
                              message: this.$t('vacation_end_after_start'),
                              type: 'error'
                          });
                        }
                    } else {
                        this.validation_err = 1;
                    }
                });
            },

            getVacation() {
                let formData = {
                    vacationable_id: this.vacationalId,
                };
                this.vacationsLoading = true;
                service.post('vacation/getEmployeevacations', formData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    // 'employeeId': atob(this.$route.params.employeeId)
                }).then((res) => {
                    this.vacationsLoading = false;
                    this.vacationList = res.data.result;
                    //console.log(this.vacationList);
                    this.running = this.vacationList.running;
                    this.upcoming = this.vacationList.upcoming;

                }).catch((err) => {
                    this.vacationsLoading = false;
                    this.$notify.error({
                        title: this.$t('error'),
                        message: this.$t('something_went_wrong')
                    });
                    console.log(err);
                });
            },

            getVacationHistory() {
                let formData = {
                    vacationable_id: this.vacationalId,
                };
                this.vacationsHistoryLoading = true;
                service.post('vacation/getEmployeeVacationHistory', formData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    // 'employeeId': atob(this.$route.params.employeeId)
                }).then((res) => {
                    //console.log(res);
                    this.vacationsHistoryLoading = false;
                    this.vacationHistory = res.data.result;
                    //console.log(this.vacationHistory);

                }).catch((err) => {
                    this.vacationsHistoryLoading = false;
                    this.$notify.error({
                        title: this.$t('error'),
                        message: this.$t('something_went_wrong')
                    });
                    console.log(err);
                });
            }
        },
        mounted() {
            this.userType=this.$cookies.get('csLogin');
            $('.custom_date input').attr('readonly','readonly');
            //console.log('userType', this.userType);
            // Employee Box Height Align
            var employeeBoxHeight = $('.js-employee-boxHeight').outerHeight();
            //alert(employeeBoxHeight);
            $('.js-employee-boxAppend').css('height', employeeBoxHeight);
            $(this.$el).find('input').datetimepicker(this.config)
            .on('dp.show', (e) => {
                const picker = e.target; // Reference to the picker element
                const currentTime = moment();

                // Check if the input is empty and set the current time in the picker
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
        },
        created() {
            this.vacationalId = this.empDetails.employable.id;
            this.fullName=this.empDetails.employable.first_name+" "+this.empDetails.employable.last_name;
            //this.vacationList = this.empDetails.employable.vacations;
            //console.log(this.empDetails);
            this.getVacation();
            this.getVacationHistory();
            //this.getAvailibityList = JSON.parse(this.empDetails.available_times);
            if (this.empDetails.available_times == null) {
                this.getAvailibityList = {
                    1: {},
                    2: {},
                    3: {},
                    4: {},
                    5: {},
                    6: {},
                    7: {}
                };
            } else {
                this.getAvailibityList = JSON.parse(this.empDetails.available_times);
            }
            //console.log(this.getAvailibityList);


        }
    }

</script>
<style scoped>
<style scoped>
.c-user-vacation-mam-height {
  min-height: 360px
}
.o-vacation-label{
  background-color: #b6b6b63d !important;
  font-size: 13px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/employees/availabilityDetails.vue